import Swiper, { EffectFade, Lazy, Navigation, Thumbs } from 'swiper';
import Component from '../../classes/Component';
import variables from '../../variables';

const rootId = 'js-repair-detail-carousel';
const viewCarouselSelector = '.js-view-swiper';
const thumbCarouselSelector = '.js-thumb-swiper';

export default function repairDetailSlider() {

  return new Component({
    name: 'repairDetailSlider',
    requiredSelector: [`#${rootId}`, viewCarouselSelector],
    rootId,
    onCreate() {
      this.viewCarousel = null;
    },
    onInit() {

      this.viewCarousel = new Swiper(`#${rootId} ${viewCarouselSelector}`, {
        speed: variables.carouselDefaultDuration / 2,
        modules: [Navigation, Lazy, EffectFade, Thumbs],
        slidesPerView: 1,
        spaceBetween: 20,
        lazy: {
          preloaderClass: variables.classNames.lazyPreloader,
          loadedClass: variables.classNames.lazyLoaded
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: `#${rootId} .swiper-button-next`,
          prevEl: `#${rootId} .swiper-button-prev`,
          disabledClass: variables.classNames.disabled,
        },
        thumbs: {
          slideThumbActiveClass: variables.classNames.active,
          autoScrollOffset: 1,
          swiper: new Swiper(`#${rootId} ${thumbCarouselSelector}`, {
            speed: variables.carouselDefaultDuration / 2,
            slidesPerView: 'auto',
            spaceBetween: 12
          })
        }
      });
      
      // console.log('dgkjdkgjdjklgjkjgdko');
      // console.log(this.viewCarousel);

    },
    onDestroy() {
      // if (this.viewCarousel instanceof Swiper) {
      //   this.viewCarousel.destroy();
      //   this.viewCarousel = null;
      // }
    }
  })
}